import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row no-gutters" };
const _hoisted_2 = { class: "col-12 p-3" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-3 text-center py-0 pr-0 align-self-start" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "col-9 pt-sm-3 pt-1 pl-lg-0 pl-3" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = {
    class: "col-md-7 mb-3",
    style: { "hyphens": "auto", "word-break": "break-word" }
};
const _hoisted_9 = { class: "h5-responsive" };
const _hoisted_10 = ["href"];
const _hoisted_11 = { class: "text-nowrap" };
const _hoisted_12 = { class: "text-nowrap" };
const _hoisted_13 = { class: "text-nowrap" };
const _hoisted_14 = { class: "col-md-5 text-right pl-0" };
const _hoisted_15 = { class: "col-12 pr-sm-3 pr-0 pl-0" };
const _hoisted_16 = { class: "h1-responsive mb-0" };
const _hoisted_17 = {
    key: 1,
    class: "fc-brand_deep_blue"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                        title: "Produktabbildung",
                        class: "sellboxImage",
                        alt: "Produktabbildung",
                        src: _ctx.productData.image
                    }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.productData.name), 1),
                            _createElementVNode("a", {
                                class: "link-in-text font7-responsive",
                                title: "Das Produkt ändern",
                                style: { "padding": "2px 5px" },
                                href: `/verkaufen/browse/${_ctx.changeProductLink}`
                            }, " Produkt ändern ", 8, _hoisted_10),
                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("div", {
                                class: _normalizeClass(["display_conditions mt-3 text", { 'd-none': _ctx.user_evaluation.condition === null }]),
                                style: { "line-height": "2em" }
                            }, [
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.product_condition_text), 1),
                                _withDirectives(_createElementVNode("span", _hoisted_12, " O.ZUBEHÖR ", 512), [
                                    [_vShow, _ctx.user_evaluation.full_scope_of_delivery === true]
                                ]),
                                _withDirectives(_createElementVNode("span", _hoisted_13, "OVP", 512), [
                                    [_vShow, _ctx.user_evaluation.ovp === true]
                                ])
                            ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font5-responsive strong mb-0" }, "Wir bieten Dir bis zu:", -1)),
                                _createElementVNode("div", _hoisted_16, [
                                    (_ctx.product_price_offer)
                                        ? (_openBlock(), _createBlock(_component_formatted_price, {
                                            key: 0,
                                            class: "fc-brand_deep_blue",
                                            price: _ctx.product_price_offer
                                        }, null, 8, ["price"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "-,-"))
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
